<template>
  <div>

    <h1 class="title d-sm-none text-center" :class="ativo==true?null:'red--text'">{{ $route.meta.breadCrumb }}</h1>

    <v-card class="mb-1">
      <!-- Toolbar -->
      <v-toolbar dense flat dark color="blue-grey darken-3">
        <v-toolbar-title class="d-none d-sm-block" :class="ativo==true?null:'red--text'">{{ $route.meta.breadCrumb }}</v-toolbar-title>
        <v-divider class="d-none d-sm-block mx-4" inset vertical></v-divider>
        
        <v-text-field v-model="dataTable.search" append-icon="mdi-magnify" label="Filtrar" single-line hide-details></v-text-field>

      </v-toolbar>

      <!-- Toolbar -->
      <v-toolbar dense flat dark color="blue-grey darken-4">
        <v-spacer></v-spacer>
        <v-toolbar-title class="d-none d-sm-block">Ações</v-toolbar-title>
        <v-divider class="d-none d-sm-block mx-4" inset vertical></v-divider>

        <v-btn @click="dialog=!dialog" title="Cadastrar" icon color="blue darken-2">
          <v-icon>fal fa-plus</v-icon>
        </v-btn>

        <v-btn title="Recarregar dados" icon @click="initialize()" color="orange lighten-1">
          <v-icon>fal fa-repeat</v-icon>
        </v-btn>

        <v-btn :title="ativo?'Mudar para intivos':'Mudar para ativos'" icon @click="ativo=!ativo" :color="ativo==true?'green':'red'">
          <v-icon>fal fa-archive</v-icon>
        </v-btn>

        <ArrayToExcel :dados="dados" :excel="excel"/>

      </v-toolbar>
    </v-card>
    
    <!-- DataTable -->
    <DataTable :dados="dados" :dataTable="dataTable">
      <template v-slot:show="{item, header}">
        <v-btn title="Mostrar" @click="showDialog(item, header)" color="white" outlined x-small>Mostrar</v-btn>
      </template>
      <template v-slot:actions="{item}">
        <v-icon small class="mr-3" title="Editar" @click="editItem(item)">far fa-pencil</v-icon>
        <v-icon small :title="ativo?'Desativar':'Ativar'" @click="deleteItem(item)">far fa-archive</v-icon>
      </template> 
    </DataTable>

    <v-dialog v-model="dialogShow" max-width="550px">
      <v-card tile>
        <v-card-title>{{ dialogShowHeader }}<v-spacer></v-spacer>
          <v-btn color="primary" @click="dialogShow=!dialogShow" icon ><v-icon>fal fa-times</v-icon></v-btn>
        </v-card-title>
        <v-list shaped>
          <v-list-item-group color="primary">
            <v-list-item v-for="data in dialogShowData" :key="data.id">
              <v-list-item-content>
                <v-list-item-title>{{ data.nome }}</v-list-item-title>
                <v-list-item-subtitle v-if="data.obs">{{ data.obs }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
    </v-dialog>

    <!-- Dialog -->
    <v-dialog v-model="dialog" max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="form">
            <v-container>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="editedItem.vida_util" label="Vida útil" :rules="[rules.required]" type="number"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="editedItem.temp_manut_prev" label="Tempo manutenção preventiva" :rules="[rules.required]" type="number"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-autocomplete
                    v-model="editedItem.maquina_id"
                    :items="dadosSelect.maquina"
                    item-text="nome"
                    item-value="id"
                    label="Máquina"
                    placeholder="Selecione uma máquina"
                    return-object
                    id="maquina"
                  >
                    <template v-slot:item="data">
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.nome"></v-list-item-title>
                        <v-list-item-subtitle v-html="data.item.descricao"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-autocomplete
                    v-model="editedItem.maq_modelo_id"
                    :items="dadosSelect.maq_modelo"
                    item-text="nome"
                    item-value="id"
                    label="Modelo"
                    placeholder="Selecione um modelo"
                    return-object
                    id="maq_modelo"
                  >
                    <template v-slot:item="data">
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.nome"></v-list-item-title>
                        <v-list-item-subtitle v-html="data.item.descricao"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-autocomplete
                    v-model="editedItem.maq_marca_id"
                    :items="dadosSelect.maq_marca"
                    item-text="nome"
                    item-value="id"
                    label="Marca"
                    placeholder="Selecione uma marca"
                    return-object
                    id="maq_marca"
                  >
                    <template v-slot:item="data">
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.nome"></v-list-item-title>
                        <v-list-item-subtitle v-html="data.item.descricao"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-autocomplete
                    v-model="editedItem.maq_marca_modelo_id"
                    :items="dadosSelect.maquina"
                    item-text="nome"
                    item-value="id"
                    label="Dentro de outra máquina"
                    placeholder="Selecione uma máquina"
                    return-object
                    id="maq_marca_modelo"
                  >
                    <template v-slot:item="data">
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.nome"></v-list-item-title>
                        <v-list-item-subtitle v-html="data.item.descricao"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="editedItem.distribuidora"
                    :items="dadosSelect.distribuidora"
                    item-text="nome"
                    item-value="id"
                    label="Distribuidora"
                    placeholder="Selecione uma ou mais"
                    multiple
                    chips
                    return-object
                    id="distribuidora"
                  >
                    <template v-slot:item="data">
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.nome"></v-list-item-title>
                        <v-list-item-subtitle v-html="data.item.descricao"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" dark @click="close"><v-icon left>fal fa-times</v-icon> Fechar</v-btn>
          <v-btn color="blue darken-1" dark @click="save"><v-icon left>fas fa-save</v-icon> Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <br style="clear:left;"/> 

	</div>
</template>

<script>
import { mapState } from 'vuex'

import ArrayToExcel from '@/components/ArrayToExcel'
import DataTable from '@/components/DataTable'

export default {
  components: {
    ArrayToExcel,
    DataTable
  },
	data () {
    return {
      server: 'maq_marca_modelo',
      ativo: true,
      dialog: false,
      dialogShow: false,
      dialogShowData: false,
      dialogShowHeader: 'Dados',
      dados: [],
      dataTable: {
        headers: [
          {	text: 'ID', value: 'id' },
          { text: 'Peça', value: 'maquina' },
          { text: 'Tipo', value: 'maq_modelo' },
          { text: 'Marca', value: 'maq_marca' },
          { text: 'Vida útil', value: 'vida_util'},
          { text: 'Tempo p/ manutenção preventiva', value: 'temp_manut_prev' },
          { text: 'Dentro de outra máquina', value: 'maq_marca_modelo' },
          { text: 'Distribuidoras', value: 'show', sortable: false },
          { text: 'Ações', value: 'actions', sortable: false }
        ],
        sortBy: 'maquina',
        sortDesc: false,
        multiSort: false,
        search: '',
        loading: true
      },
      excel: { 
        name: undefined,
        fields: {
          'Id': 'id',
          'Peça': 'maquina',
          'Tipo': 'maq_modelo',
          'Marca': 'maq_marca',
          'Vida útil': 'vida_util',
          'Tempo p/ manutenção preventiva': 'temp_manut_prev',
          'Dentro de outra máquina': 'maq_marca_modelo: '
        }
      },
			editedIndex: -1,
			editedItem: {
        id: '',
        vida_util: '',
        temp_manut_prev: '',
        maquina_id: '',
        maq_modelo_id: '',
        maq_marca_id: '',
        distribuidora: [],
        maq_marca_modelo: '',
        maq_marca_modelo_id: ''
			},
			defaultItem: {
        id: '',
        vida_util: '',
        temp_manut_prev: '',
        maquina_id: '',
        maq_modelo_id: '',
        maq_marca_id: '',
        distribuidora: [],
        maq_marca_modelo: '',
        maq_marca_modelo_id: ''
      },
      dadosSelect: {
        maquina: [],
        maq_modelo: [],
        maq_marca: [],
        distribuidora: []
      }
		}
  },
  computed: {
    ...mapState(
      ['user', 'rules']
    ),
    formTitle () {
      return this.editedIndex === -1 ? 'Cadastrar' : 'Editar'
    }
  },

  watch: {
    dialog(val) { 
      val? this.getDadosSelects() : this.close()
    },
    ativo(){ this.initialize() }
  },
  created () {
    this.initialize()
  },

  methods: {
    excelName(){
      this.excel.name = this.$route.meta.breadCrumb+"-"+Date()+".xls"
    },
    initialize(){
      this.excelName()
      this.dataTable.loading = true
      let formData = new FormData()
      formData.append('menu', this.server)
      formData.append('function', 'get_'+this.server)
      formData.append('ativo', this.ativo)
      let vd = this
      
      this.$axiosPost.post('functions.php', formData, 
      { headers: {'Authorization': this.user.token} })
			.then(function (response) {
        if(response.data.error === 0){
          vd.dados = response.data.dados
          setTimeout(function(){ vd.dataTable.loading = false }, 1000)
        }else{
          vd.$store.dispatch('errorServer', { data: response.data, destino: vd.$route.path } )
        }
			}).catch(function(response){
        console.log('ERRO!! '+response);
      })
    },
    getDadosSelects(){
      let formData = new FormData()
      formData.append('menu', this.server)
      formData.append('function', 'formSelect_'+this.server)
      let vd = this
      
      this.$axiosPost.post('functions.php', formData, 
      { headers: {'Authorization': this.user.token} })
			.then(function (response) {
        if(response.data.error === 0){
          vd.dadosSelect.maquina = response.data.maquina
          vd.dadosSelect.maq_modelo = response.data.maq_modelo
          vd.dadosSelect.maq_marca = response.data.maq_marca
          vd.dadosSelect.distribuidora = response.data.distribuidora
        }else{
          vd.$store.dispatch('errorServer', { data: response.data, destino: vd.$route.path } )
        }
			}).catch(function(response){
        console.log('ERRO!! '+response);
      })
    },

    showDialog(item, header){
      console.log(item, header);
      this.dialogShowData = Object.assign({}, item.distribuidora)
      this.dialogShowHeader = header
      this.dialogShow = true
    },

    editItem(item){
      this.editedIndex = this.dados.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem(item){
      this.excelName()
      const index = this.dados.indexOf(item)
      let formData = new FormData()
      formData.append('menu', this.server)
      formData.append('function', 'delete_'+this.server)
      formData.append('ativo', !this.ativo)
      formData.append('id', item.id)
      let vd = this
      this.$axiosPost.post('functions.php', formData,
      { headers: {'Authorization': this.user.token} })
      .then(function (response) {
        if(response.data.error === 0){
          vd.dados.splice(index, 1)
          vd.$store.dispatch('alert', { alertMessage: response.data.alertMessage, alertType:0 } )
        }else{
          vd.$store.dispatch('errorServer', { data: response.data, destino: vd.$route.path } )
        }
      }).catch(function(response){
        console.log('ERRO!! '+response);
      })
    },

    close(){
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.$refs.form.resetValidation()
      }, 300)
    },

    save(){
      if(this.$refs.form.validate()){
        if(this.editedItem.maquina_id.id != undefined){
          this.editedItem.maquina = this.editedItem.maquina_id.nome
          this.editedItem.maquina_id = this.editedItem.maquina_id.id
        }
        if(this.editedItem.maq_modelo_id.id != undefined){
          this.editedItem.maq_modelo = this.editedItem.maq_modelo_id.nome
          this.editedItem.maq_modelo_id = this.editedItem.maq_modelo_id.id
        }
        if(this.editedItem.maq_marca_id.id != undefined){
          this.editedItem.maq_marca = this.editedItem.maq_marca_id.nome
          this.editedItem.maq_marca_id = this.editedItem.maq_marca_id.id
        }

        if(this.editedItem.maq_marca_modelo_id !== null && typeof this.editedItem.maq_marca_modelo_id === 'object'){
          this.editedItem.maq_marca_modelo = this.editedItem.maq_marca_modelo_id.nome
          this.editedItem.maq_marca_modelo_id = this.editedItem.maq_marca_modelo_id.id
        }

        let formData = new FormData()
        Object.entries(this.editedItem).forEach(([key, value]) => {
          if(key != 'distribuidora') formData.append(key, value)
        })
        let distribuidora = ''
        Object.entries(this.editedItem.distribuidora).forEach(([key, value]) => {
          Object.entries(value).forEach(([key2, value2]) => {
            if(key2 == 'id'){
              if(key > 0){ distribuidora += ',' }
              distribuidora += value2
            }
          })
        })
        if(distribuidora != '') formData.append('distribuidora', distribuidora)
        formData.append('menu', this.server)
        formData.append('function', 'update_'+this.server)
        
        this.excelName()
        if (this.editedIndex > -1) {
          // Alterar
          let vd = this
          this.$axiosPost.post('functions.php', formData,
          { headers: {'Authorization': this.user.token} })
          .then(function (response) {
            if(response.data.error === 0){
              vd.initialize()
              vd.$store.dispatch('alert', { alertMessage: response.data.alertMessage, alertType:0 } )
            }else{
              vd.$store.dispatch('errorServer', { data: response.data, destino: vd.$route.path } )
            }
          }).catch(function(response){
            console.log('ERRO!! '+response);
          })

        }else{
          // Salvar
          formData.append('menu', this.server)
          formData.append('function', 'insert_'+this.server)
          let vd = this
          this.$axiosPost.post('functions.php', formData,
          { headers: {'Authorization': this.user.token} })
          .then(function (response) {
            if(response.data.error === 0){
              vd.editedItem.id = response.data.id
              vd.initialize()
              vd.$store.dispatch('alert', { alertMessage: response.data.alertMessage, alertType:0 } )
            }else{
              vd.$store.dispatch('errorServer', { data: response.data, destino: vd.$route.path } )
            }
          }).catch(function(response){
            console.log('ERRO!! '+response);
          })

        }
      }
    }
  },
}
</script>